module.exports = __webpack_public_path__ + "img/90501207hk.e6299e8e.png";